import React, { useEffect } from "react";
import moment from "moment-timezone";
import { Col, Row, Card, Image, Button, Container, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FacebookIcon, TwitterIcon } from "components/BrandIcons";
import logo from "../assets/img/Telkosh.png";
import bockcubeLogo from "../assets/img/blockcube.png";



import { Routes } from "routes";
import { GithubIcon } from "components/BrandIcons";


export default () => {
  useEffect(() => {
    // Keys to retain in localStorage
    const keysToRetain = ["rememberMe", "rememberedEmail", "rememberedPhone", "rememberChecked"];

    // Backup values of keys to retain
    const backup = {};
    keysToRetain.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value !== null) {
        backup[key] = value;
      }
    });

    // Clear all items in localStorage
    localStorage.clear();

    // Restore the retained keys and values
    Object.entries(backup).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  }, []);


  const currentYear = moment().get("year");



  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection:'column' }} className="bg-primary">
      <Navbar variant="dark" expand="lg" bg="dark" className="navbar-transparent navbar-theme-primary sticky-top">
        <Container className="position-relative justify-content-between px-3">
          <Navbar.Brand as={HashLink} to="#home" className="me-lg-3 d-flex align-items-center">
          </Navbar.Brand>

          <div className="d-flex align-items-center">
            <Button as={HashLink} to={Routes.Signin.path} variant="outline-white" className="ms-3">Sign In</Button>
          </div>
        </Container>
      </Navbar>
      <section className="main-section text-white" id="home">
        <Container>
          <Row>
            <Col xs={12} className="text-center">
              <div style={{ margin: "auto", maxWidth: '300px', background: "#ffffff66", borderRadius: "12px", padding: "15px 20px"  }}>
                <Image src={logo} alt="logo" />
              </div>
              <p className="text-muted fw-light h5">Premium automation tool powered by &nbsp;<img width="25%" src={bockcubeLogo} alt="logo-blockcube"></img></p>
            </Col>
          </Row>
        </Container>
      </section>
      <footer className="footer text-white">
        <Container>
          <Row>
            <Col md={4}>
              <Navbar.Brand as={HashLink} to="#root" className="">
                <div style={{ width: "130px", background: "#ffffff66", borderRadius: "10px", padding: "10px" }}>
                  <Image src={logo} alt="logo" />
                </div>
              </Navbar.Brand>
              <p className="text-muted font-small m-0 mb-2">A Premium Messaging Automation Tool</p>
              <div className="mt-2 d-flex">
                <Button variant="outline-gray-500" className="btn-icon-only btn-pill me-2">
                  <FacebookIcon size="xs" color="currentColor" />
                </Button>
                <Button variant="outline-gray-500" className="btn-icon-only btn-pill me-2">
                  <TwitterIcon size="xs" color="currentColor" />
                </Button>
                <Button variant="outline-gray-500" className="btn-icon-only btn-pill">
                  <GithubIcon size="xs" color="currentColor" />
                </Button>
              </div>
            </Col>
            <Col xs={6} md={2} className="mb-5 mb-lg-0">
              <span className="h5">COMPANY</span>
              <ul className="links-vertical mt-2">
                <li><Card.Link target="_blank" href="#">Blog</Card.Link></li>
                <li><Card.Link target="_blank" href="#">Products</Card.Link></li>
                <li><Card.Link target="_blank" href="#">About Us</Card.Link></li>
                <li><Card.Link target="_blank" href="#">Contact Us</Card.Link></li>
              </ul>
            </Col>
            <Col xs={12} md={4} className="mb-5 mb-lg-0">
              <span className="h5 mb-3 d-block">SUBSCRIBE</span>
              <form action="#">
                <div className="form-row mb-2">
                  <div className="col-12">
                    <input type="email" className="form-control mb-2" placeholder="example@company.com" name="email" aria-label="Subscribe form" required />
                  </div>
                  <div className="col-12 d-grid gap-2">
                    <button type="button" className="btn btn-secondary text-dark shadow-soft" data-loading-text="Sending">
                      <span>Subscribe</span>
                    </button>
                  </div>
                </div>
              </form>
              <p className="text-muted font-small m-0">We’ll never share your details. See our <Card.Link className="text-white" href="#">Privacy Policy</Card.Link></p>
            </Col>
          </Row>
          <hr className="bg-gray-600" />
          <Row>
            <Col className="mb-md-2">
              <Card.Link href="#" target="_blank" className="d-flex justify-content-center">
      
              </Card.Link>
              <div className="d-flex text-center justify-content-center align-items-center" role="contentinfo">
                <p className="font-weight-normal font-small mb-0">Copyright &#169; telKosh 2019-<span className="current-year">{currentYear}</span>. All rights reserved.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};
